import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel'
import Client from '../Client/Client';
import VehicleInformation from './Vehicle/VehicleInformation';

const ClientVehicle = ({
    registrationIdsSelected
}) => {
    const [clientIdSelected, setClientIdSelected] = useState([]);

    return (
        <Panel style={{
            display: 'flex',
            flexDirection: 'row',
        }}>
            <Panel
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    minWidth: 'calc(50% - 15px)',
                }}>
                <Client
                    registrationIdsSelected={registrationIdsSelected}
                    clientIdSelected={clientIdSelected}
                    onUpdateClientId={setClientIdSelected}
                />

            </Panel>
            <VehicleInformation clientIdSelected={clientIdSelected[0]} />
        </Panel>
    );

}

export default ClientVehicle;